import {$qs, loadScript} from '../../@shared/ts/dom';
import {type IResponse} from '../../@type/response';

declare const peachpay_admin: PeachPayAdminData;

function botProtectionUI() {
	const toggle = $qs<HTMLInputElement>('#peachpay_bot_protection_admin_settings_enabled');
	const siteKey = $qs<HTMLInputElement>('#peachpay_bot_protection_admin_settings_site_key');
	const secretKey = $qs<HTMLInputElement>('#peachpay_bot_protection_admin_settings_secret_key');
	const form = $qs<HTMLFormElement>('form');

	if (!toggle || !siteKey || !secretKey || !form) {
		return;
	}

	const siteKeyMessage = document.createElement('span');
	siteKeyMessage.style.fontSize = '12px';
	siteKeyMessage.style.color = 'red';
	siteKey.parentElement?.insertAdjacentElement('afterend', siteKeyMessage);

	const secretKeyMessage = document.createElement('span');
	secretKeyMessage.style.fontSize = '12px';
	secretKeyMessage.style.color = 'red';
	secretKey.parentElement?.insertAdjacentElement('afterend', secretKeyMessage);

	const clearMessage = () => {
		siteKeyMessage.innerText = '';
		secretKeyMessage.innerText = '';
	};

	const displayMissingKeyMessage = () => {
		if (!siteKey.value) {
			siteKeyMessage.innerText = 'Missing site key.';
		}

		if (!secretKey.value) {
			secretKeyMessage.innerText = 'Missing secret key.';
		}
	};

	const clearSavingBanner = () => {
		$qs('#saving-changes-peachpay_message')?.remove();
	};

	form.addEventListener('submit', async event => {
		clearMessage();
		if (toggle.checked && (!siteKey.value || !secretKey.value)) {
			event.preventDefault();
			displayMissingKeyMessage();
			clearSavingBanner();
		}

		if (toggle.checked && siteKey.value && secretKey.value) {
			event.preventDefault();
			const token = await validateSiteKey(siteKey.value);
			if (token instanceof Error) {
				siteKeyMessage.innerText = token.message;
				clearSavingBanner();
				return;
			}

			const response = await validateSecretKey(secretKey.value, token as string);
			if (!response.success) {
				secretKeyMessage.innerText = response.message ?? '';
				clearSavingBanner();
				return;
			}

			form.submit();
		}
	});
}

async function validateSecretKey(secretKey: string, token: string) {
	const formData = new FormData();
	formData.append('action', 'pp-captcha-validate');
	formData.append('security', peachpay_admin.nonces.captcha_validation);
	formData.append('secret_key', secretKey);
	formData.append('captcha_token', token);

	const response = await fetch(peachpay_admin.admin_ajax, {
		method: 'POST',
		body: formData,
	});

	const data = await response.json() as IResponse<void>;

	return data;
}

async function validateSiteKey(siteKey: string) {
	document.querySelector('script[src^=\'https://www.google.com/recaptcha/api.js\']')?.remove();

	(window as any).grecaptcha = null;

	await loadScript('https://www.google.com/recaptcha/api.js?render=' + siteKey, null);

	return new Promise(resolve => {
		grecaptcha.ready(async () => {
			try {
				const token = await grecaptcha.execute(siteKey, {action: 'verify'});
				resolve(token);
			} catch (error: any) {
				resolve(new Error(error));
			}
		});
	});
}

export {botProtectionUI};
